import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { IDCardRequestModel } from "./IDCardRequestModel";
import { FacilityRequestModel } from "./FacilityRequestModel";
import { StringRequest } from "../../school-type-setup/shared/StringRequest";

@Injectable()
export class DataService_FacilitySetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadFacility(UserID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/LoadFacilityFullInfo?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadIDCardTemplates(FacilityID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/LoadIDCardTemplates?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadMSIDCardTemplates(FacilityID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/LoadMSIDCardTemplates?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FacilityInsert(parms: FacilityRequestModel) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/FacilityInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FacilityUpdate(parms: FacilityRequestModel) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/FacilityUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FacilityNameInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/FacilityNameInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FacilityCDInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/FacilityCDInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FacilityLoadData(FacilityID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/FacilityLoadData?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ToggleFacility(FacilityID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ToggleFacility?FacilityID=" + FacilityID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
